import React, { useState, useEffect } from "react";
import CardShoppingHistory from "./CardShoppingHistory";
import { getOrders } from "../../../services/getOrders";
import { useUser } from "../../../Context/UserContext";

function displayThisSection(displayThis, isEmptyBlock, listSize) {
  if (displayThis === 2 && (listSize > 0) ^ isEmptyBlock) {
    return "flex";
  } else {
    return "none";
  }
}

const CardsListShoppingHistory = (props) => {
  const { user } = useUser(); // Obtiene el usuario
  const [pastPurchases, setPastPurchases] = useState([]);

  useEffect(() => {
    async function fetchOrders() {
      if (!user?.id) {
        //console.log("No hay usuario aún");
        return;
      }

      try {
        const { orders } = await getOrders(user.id); // Obtiene solo órdenes obtenidas
        
        const warehouseMap = {
          1: "ASEIC",
          2: "AEMTEC",
          4: "AESETEC",
          6: "ADESC",
        };

        const formattedOrders = orders.map((order) => ({
          code: order.orderId,
          date: order.date,
          price: parseInt(order.total).toFixed(0),
          status: order.tag,
          warehouse: warehouseMap[order.warehouse] || "Desconocido",
          description: order.orderName,
        }));

        setPastPurchases(formattedOrders);
      } catch (error) {
        console.error("Error al obtener las órdenes:", error);
      }
    }

    fetchOrders();
  }, [user]);

  const displaySection = displayThisSection(
    props.displayThis,
    false,
    pastPurchases.length
  );
  const displayMessageForEmpty = displayThisSection(
    props.displayThis,
    true,
    pastPurchases.length
  );

  return (
    <>
      <div
        style={{
          display: displayMessageForEmpty,
          textAlign: "center",
          fontSize: "1.8rem",
          fontWeight: "bold",
          color: "#ff6b6b",
          padding: "2rem",
          fontFamily: "'Poppins', sans-serif",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
        className="empty-cart-block"
      >
        No tienes historial de compras <br /> ¡comienza a comprar ahora!
      </div>
      <div style={{ display: displaySection }}>
        <div
          style={{
            flexFlow: "column",
            maxHeight: "500px",
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: 50,
            paddingTop: "15px",
          }}
        >
          {pastPurchases.map((purchase, prodIndex) => (
            <CardShoppingHistory key={prodIndex} purchaseData={purchase} />
          ))}
        </div>
      </div>
    </>
  );
};

export default CardsListShoppingHistory;
